/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Confirmationemailprocessfinished3Inputs */

const de__field_confirmationemailprocessfinished3 = /** @type {(inputs: _Field_Confirmationemailprocessfinished3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungsemail-Prozess abgeschlossen`)
};

/**

* @param {_Field_Confirmationemailprocessfinished3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_confirmationemailprocessfinished3 = /** @type {((inputs?: _Field_Confirmationemailprocessfinished3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Confirmationemailprocessfinished3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_confirmationemailprocessfinished3(inputs)
});
export { _field_confirmationemailprocessfinished3 as "_field_confirmationEmailProcessFinished" }